export enum ActivitiesType {
  LOCATION = '1',
  ATTRACTION = '0',
}

export enum ActivitiesOrdering {
  ASCENDING = 3,
  DESCENDING = 4,
  RATINGS = 2,
  RECOMMENDED = 1,
}

export interface ActivitiesPaging {
  start: number;
  end: number;
  index: number;
  size: number;
}
